module.exports = __webpack_public_path__ + "static/media/facebook.dc060f54.svg";